module.exports = {"371721001":"曹城街道","371721002":"磐石街道","371721003":"青菏街道","371721004":"郑庄街道","371721005":"倪集街道","371721101":"庄寨镇","371721102":"普连集镇","371721103":"青固集镇","371721104":"桃源集镇","371721105":"韩集镇","371721106":"砖庙镇","371721107":"古营集镇","371721108":"魏湾镇","371721109":"侯集回族镇","371721110":"苏集镇","371721111":"孙老家镇","371721112":"阎店楼镇","371721113":"梁堤头镇","371721114":"安才楼镇","371721115":"曹县邵庄镇","371721116":"曹县王集镇","371721117":"青岗集镇","371721120":"常乐集镇","371721121":"曹县大集镇","371721122":"曹县仵楼镇","371721203":"曹县楼庄乡","371721207":"曹县朱洪庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371721.json
// module id = 1503
// module chunks = 0